/* ExecutionLogComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ExecutionLogRenderer");

class ExecutionLogComponent extends EventEmitter {
    constructor(logger, gameEditor, state, io) {
        super();

        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;

        this._executionEntity = _.get(state, "configExecutionEntity", undefined);
        this._logFeed = undefined;
        this._renderer = new Renderer(this);
    }

    /*whenModelIsReady() {
        return this._gameEditor
            .whenPolicyIsReady()
            .then(() => {
                return this._executionEntity.loadRelatedWork({ log: true });
            })
            .then((workEntity) => {
                this._logFeed = workEntity.log;
                return Promise.resolve();
            });
    }*/

    async whenModelIsReady() {
        let work = await this._executionEntity.loadRelatedWork({log: true});
        this._logFeed = await work.startRelatedLogFeed();
        this._registerListeners();
        return Promise.resolve();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._logFeed.on("InstanceAdded", (this._onLogsAdded = this._onLogsAdded.bind(this)));
    }

    _unregisterListeners() {
        if (this._logFeed) {
            this._logFeed.removeListener("InstanceAdded", this._onLogsAdded);
        }
    }

    _onLogsAdded(logs) {
        this.emit("LogsAdded", logs.getPristineProperties().log);
    }

    /****************************************/
    /* END PRIVATE COMPONENT MODEL METHODS  */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /****************************************/

    get io() {
        return this._io;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._executionEntity = undefined;
        this._logFeed = undefined;
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        return Promise.resolve(prom).then(() => {});
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    getLogs() {
        return this._logFeed;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = ExecutionLogComponent;
ExecutionLogComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.viewState",
    "$teve.io",
];
ExecutionLogComponent.$displayDetails = {
    type: "View",
    name: "Execution Log",
    icon: "common.edit",
    shown: false,
};
